module.exports = __webpack_public_path__ + "img/t2-c8.b4905c5b.png";